import { DecoratorNode, NodeKey, SerializedLexicalNode, Spread } from 'lexical';
import styles from '../RichTextEditor.module.scss';

type SerializedPageBreakNode = Spread<
  {
    type: 'pagebreak';
    version: 1;
  },
  SerializedLexicalNode
>;

export class PageBreakNode extends DecoratorNode<JSX.Element> {
  static getType(): string {
    return 'pagebreak';
  }

  static clone(node: PageBreakNode): PageBreakNode {
    return new PageBreakNode(node.__key);
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(key?: NodeKey) {
    super(key);
  }

  createDOM(): HTMLElement {
    const div = document.createElement('div');
    div.className = styles.pageBreak;
    return div;
  }

  updateDOM(): false {
    return false;
  }

  static importJSON(): PageBreakNode {
    return new PageBreakNode();
  }

  exportJSON(): SerializedPageBreakNode {
    return {
      type: 'pagebreak',
      version: 1,
    };
  }
}

export function createPageBreakNode(): PageBreakNode {
  return new PageBreakNode();
}
